




import {Component, Prop, Vue} from "vue-property-decorator";
import {ReceiptExpensePickingListPayStatus} from "@/enums/status";

@Component({
  name: "ReceiptExpensePickingListPayStatusLabel"
})
export default class extends Vue {
  @Prop({ type: Number, required: true }) readonly status!: number;

  ReceiptExpensePickingListPayStatus = ReceiptExpensePickingListPayStatus;
}
